export default __webpack_public_path__ + "static/media/post_step2.61a9921e.png";